import { useState, useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Card, Container } from '@mui/material';

import { marked } from 'marked';
import { useTranslation } from 'react-i18next';

import CurrencyConverter from 'components/CurrencyConverter'
import servicesContext from 'servicesContext';

import useCurrencyURLParams from './useCurrencyURLParams';

const { currencyExchangeService } = servicesContext;

const StyledContent = styled('div')({
    maxWidth: 900,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 30,
    marginTop: 20,
});

const getExchangeRate = async (baseCurrency, targetCurrency) => (
    currencyExchangeService.getExchangeRate(baseCurrency, targetCurrency)
);

const convertMarkdownToHtml = (markdownText) => (
    marked.parse(markdownText)
);

export default function HomePage() {

    const { t } = useTranslation();

    const [currencies, setCurrencies] = useState(null);
    const [overallInsight, setOverallInsight] = useState(null);

    const {
        amount: initialAmount, fromCurrency: initialFromCurrency, toCurrency: initialToCurrency,
        updateAmount, updateFromCurrency, updateToCurrency,
    } = useCurrencyURLParams();

    useEffect(() => {

        const fetchCurrencies = async () => {
            const currencies = await currencyExchangeService.getSupportedCurrencies();
            setCurrencies(currencies);
        };

        fetchCurrencies();
    }, []);

    useEffect(() => {

        const fetchCurrencies = async () => {
            const { insight } = await currencyExchangeService.getOverallInsight();
            const insightMarkdown = JSON.parse(insight).content;
            const insightHtml = convertMarkdownToHtml(insightMarkdown)
            setOverallInsight(insightHtml);
        };

        fetchCurrencies();
    }, []);

    return (
        <>
            <Container>
                <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
                    <Card sx={{ width: '100%', px: 1, py: 4, mt: 2 }}>
                        {currencies &&
                            <CurrencyConverter
                                currencies={currencies}
                                initialAmount={initialAmount}
                                initialFromCurrency={initialFromCurrency || 'USD'}
                                initialToCurrency={initialToCurrency || 'EUR'}
                                onAmountChange={updateAmount}
                                onFromCurrencyChange={updateFromCurrency}
                                onToCurrencyChange={updateToCurrency}
                                getExchangeRate={getExchangeRate}
                            />
                        }
                    </Card>
                    <Card sx={{ width: '100%', px: 6, py: 4, mt: 4, textAlign: 'left' }}>
                        <h2>{t('insightsPanel.panelTitle')}</h2>
                        {overallInsight &&
                            <>
                                {/* eslint-disable-next-line react/no-danger */}
                                <div dangerouslySetInnerHTML={{ __html: overallInsight }} />
                                <div style={{ fontStyle: 'italic' }}>
                                    {t('insightsPanel.legalDisclaimer')}
                                </div>
                            </>
                        }
                    </Card>
                </StyledContent>
            </Container>
        </>
    );
}
